module.exports = __webpack_public_path__ + "img/wb_logo.ec075cd0.png";